export default "__VITE_ASSET__PuuaL0as__"